import { observer } from 'mobx-react-lite'
import { IconButton, Tooltip } from 'shared/ui'
import { downloadFile } from 'shared/lib'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { usePresentationModeContext } from 'widgets/PresentationMode'

export const DownloadPreviewBtn = observer(() => {
  const { organizationStore } = useEntitiesContext()
  const { currentAttachment, shouldTrackEvent } = usePresentationModeContext()
  const onDownload = () => {
    if (currentAttachment?.source) {
      downloadFile(currentAttachment?.source)

      if (organizationStore.isHipaaCompliant && shouldTrackEvent) {
        organizationStore.handleTrackOrganizationActivity({
          event: 'phi.file.downloaded',
          data: {
            file_ids: [Number(currentAttachment.id)],
          },
        })
      }
    }
  }

  return (
    <Tooltip label={'Download'}>
      <IconButton
        icon={'download'}
        color={'secondary'}
        variant={'icon'}
        onClick={onDownload}
        ariaLabel='DownloadPreviewBtn'
      />
    </Tooltip>
  )
})
